module.exports = __webpack_public_path__ + "static/media/kaggle_taxi.73c324d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ml/kaggle_taxi.png
// module id = 596
// module chunks = 0